export default __webpack_public_path__ + "static/media/KinematicsImg.0b3d5096.png";